<!-- TOP CARDS FOR DASHBOARD -->
@let isTopCardValue = isTopCard();
@let warningsPerTypeValue = warningsPerType();
@let warningsList = warningsPerTypeValue | keyvalue;

@if (isTopCardValue && warningsList.length > 0) {
  <ng-template #topCardsDashboardWarning>
    <div class="top-cards-grid">
      @if (
        !areThereActiveWinterWarnings() && !areThereActiveWeatherWarnings()
      ) {
        <mat-card
          appearance="outlined"
          class="top-warn-card border-NOWARN"
          (click)="onNavigateToWarningPage()">
          <p class="top-warn-label">{{ 'HOME.WARNING.ACTIVE' | translate }}</p>
          <h1 class="warn-number warn-NOWARN">
            <fa-icon
              [icon]="['far', 'exclamation-triangle']"
              class="warn-icon-glow"></fa-icon>
            &nbsp; 0
          </h1>
        </mat-card>
      }
      @if (
        warningsPerTypeValue.hasOwnProperty('summer') &&
        warningsPerTypeValue['summer'].hasOwnProperty('VORAB')
      ) {
        <mat-card
          appearance="outlined"
          class="top-warn-card border-VORAB"
          (click)="onNavigateToWarningPage()">
          <p class="top-warn-label">{{ 'HOME.WARNING.INFO' | translate }}</p>
          <h1 class="warn-number warn-VORAB">
            <fa-icon
              [icon]="['far', 'exclamation-triangle']"
              class="warn-icon-glow"></fa-icon>
            &nbsp;
            {{ warningsPerTypeValue['summer']['VORAB'] }}
          </h1>
        </mat-card>
      }
      @if (
        warningsPerTypeValue.hasOwnProperty('summer') &&
        warningsPerTypeValue['summer'].hasOwnProperty('WARN')
      ) {
        <mat-card
          appearance="outlined"
          class="top-warn-card border-WARN"
          (click)="onNavigateToWarningPage()">
          <p class="top-warn-label">{{ 'HOME.WARNING.WEATHER' | translate }}</p>
          <h1 class="warn-number warn-WARN">
            <fa-icon
              [icon]="['far', 'exclamation-triangle']"
              class="warn-icon-glow"></fa-icon>
            &nbsp;
            {{ warningsPerTypeValue['summer']['WARN'] }}
          </h1>
        </mat-card>
      }
      @if (
        warningsPerTypeValue.hasOwnProperty('winter') &&
        warningsPerTypeValue['winter'].hasOwnProperty('WARN')
      ) {
        <mat-card
          appearance="outlined"
          class="top-warn-card border-WARN"
          (click)="onNavigateToWarningPage()">
          <p class="top-warn-label">
            {{ 'HOME.WARNING.SLIPPERY' | translate }}
          </p>
          <h1 class="warn-number warn-WARN">
            <fa-icon
              [icon]="['far', 'exclamation-triangle']"
              class="warn-icon-glow"></fa-icon>
            &nbsp;
            {{ warningsPerTypeValue['winter']['WARN'] }}
          </h1>
        </mat-card>
      }
    </div>
  </ng-template>
}

@let displayedWarningValue = displayedWarning();
@if (displayedWarningValue) {
  <div class="warning-detail-container">
    <ng-container
      *ngTemplateOutlet="
        warningContent;
        context: { $implicit: displayedWarningValue }
      "></ng-container>
  </div>
} @else if (isLoading()) {
  <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
  </app-loading-overlay>
}

<ng-template #warningContent let-warning>
  <div class="warning-header-wrapper" [ngClass]="'warn-' + warning['type']">
    <div class="warning-header-icon-zone">
      <fa-icon [icon]="['far', warning['symbol']]" size="3x"></fa-icon>
    </div>

    <div class="warning-header-text-zone">
      @if (warning['type'] !== 'VORAB' && warning['type'] !== 'WARN') {
        <h3 class="warning-title">
          {{ 'PRODUCT.WARNING.TYPE.' + warning['type'] | translate }}
        </h3>
      }
      @if (warning['type'] === 'VORAB' || warning['type'] === 'WARN') {
        <h3 class="warning-title-compact">
          {{ 'PRODUCT.WARNING.TYPE.' + warning['type'] | translate }}
        </h3>
        <div class="warning-meta-date">
          <fa-icon [icon]="['far', 'clock']"></fa-icon>
          <span>
            {{
              warning.dtg
                | datex
                  : 'dd DD.MM.YY HH:mm'
                  : undefined
                  : languageService.langSignal()
            }}
            {{ 'DATETIME.CLOCK' | translate }}
          </span>
        </div>
      }
    </div>
  </div>

  <!-- Inhaltsbereiche je nach Warnungstyp (Backend-Texte hübsch verpackt) -->
  <div class="warning-body-content">
    @if (
      warning['type'] === 'NOWARN' ||
      warning['type'] === 'ENTWARN' ||
      warning['type'] === 'AUTOENTWARN'
    ) {
      <div class="no-warn-text-box">
        <fa-icon
          [icon]="['far', 'check-circle']"
          class="success-status-icon"></fa-icon>
        <p>{{ warning['message'] | translate }}</p>
      </div>
    }

    @if (warning['type'] === 'VORAB') {
      <div class="vorab-scroll-container">
        @for (
          line of warning['message'].split(',,');
          track $index;
          let i = $index
        ) {
          @if (i > 0) {
            <div class="vorab-message-block">
              @for (chunk of line.split(','); track $index; let j = $index) {
                <div
                  [ngClass]="
                    j === 0 ? 'vorab-chunk-title' : 'vorab-chunk-text'
                  ">
                  {{ chunk }}
                </div>
              }
            </div>
          }
        }
      </div>
    }

    @if (warning['type'] === 'WARN') {
      <div class="warn-text-box">
        <p class="backend-warn-p">{{ warning['message'] }}</p>
      </div>
    }
  </div>
</ng-template>
